import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {Subscription} from "../models/subscription.model";

@Injectable()
export class SubscriptionDataSource {
    private readonly baseUrl = environment.backendApi + 'api/Subscription';

    constructor(private http: HttpClient) {
    }

    /**
     * Fetches a subscription by its ID.
     * @param id The subscription ID.
     * @returns An Observable of a Subscription object.
     */
    getSubscriptionById(id: number): Observable<Subscription> {
        return this.http.get<Subscription>(`${this.baseUrl}/${id}`);
    }

    /**
     * Fetches all subscriptions.
     * @returns An Observable array of Subscription objects.
     */
    getAllSubscriptions(): Observable<Subscription[]> {
        return this.http.get<Subscription[]>(`${this.baseUrl}/GetAllSubscriptions`);
    }

    /**
     * Fetches subscriptions by organization.
     * @param organizationId The organization ID.
     * @returns An Observable array of Subscription objects.
     */
    getSubscriptionsByOrganization(organizationId: number): Observable<Subscription[]> {
        return this.http.get<Subscription[]>(`${this.baseUrl}/GetSubscriptionsByOrganization/${organizationId}`);
    }

    /**
     * Creates a new subscription.
     * @param subscription The subscription object to create.
     * @returns Observable of the created subscription ID.
     */
    createSubscription(subscription: Partial<Subscription>): Observable<number> {
        return this.http.post<number>(`${this.baseUrl}/CreateSubscription`, subscription);
    }

    /**
     * Updates an existing subscription.
     * @param subscription The subscription object to update.
     * @returns Observable of the API response.
     */
    updateSubscription(subscription: Subscription): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/UpdateSubscription/${subscription.id}`, subscription);
    }

    /**
     * Deletes a subscription by its ID.
     * @param id The subscription ID.
     * @returns Observable of the API response.
     */
    deleteSubscription(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/DeleteSubscription/${id}`);
    }

    /**
     * Initiates a subscription for a specific company and plan.
     * @param companyId The organization ID.
     * @param planId The plan ID.
     * @returns Observable of the API response.
     */
    initiateSubscription(companyId: number, planId: number): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/InitiateSubscription`, {companyId, planId});
    }


}
